// extracted by mini-css-extract-plugin
export var typingIndicator = "_lx-0";